export default __webpack_public_path__ + "cecf02a48fa7aed6a325ec8c5b37faef.png";